export enum MessageBackgroundColors {
    Gray = 'gray',
    Blue = 'blue',
    Green = 'green',
}
